import Vue from 'vue'
import Vuex from 'vuex'

import IndexStore from './modules/IndexStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    IndexStore
  }
})
